Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-landing-form'), form, formData;

    if ($form.length < 1)
        return;

    form = $form.get(0);

    formData = {
        competition: $form.data("competition"),
        email: "",
        firstname: "",
        lastname: "",
        message: "",
        newsletter: false,
        address: "",
        phone: "",
        mobilephone: "",
        fax: "",
        gender: "",
        customxml: "",
        reCaptchaCode: "",
        terms: false
    };

    // reCAPTCHA
    var captchaId = "landingCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;


    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data.success && data.code === "Landing_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();
            $('html,body').animate({ scrollTop: $('.js-success', $form).offset().top - 100 }, 300);

            form.removeRecaptcha();
        } else {
            $('.js-error', $form).show();
            $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);

            form.resetRecaptcha();
        }
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
        $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Landing Page', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    };

    form.submit = function () {
        form.loading(true);

        Vendd.MessageBus.publishAsync(form, new Vendd.Landing.Messages.Submit(
            formData.competition,
            formData.email,
            formData.firstname,
            formData.lastname,
            formData.message,
            formData.newsletter,
            formData.address,
            formData.phone,
            formData.mobilephone,
            formData.fax,
            formData.gender,
            formData.customxml,
            formData.reCaptchaCode,
            $('input[name="terms"]:checked').length > 0
        ));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="email"]', $form).val("");
        $('input[name="firstname"]', $form).val("");
        $('input[name="lastname"]', $form).val("");
        $('input[name="message"]', $form).val("");
        $('input[name="newsletter"]', $form).prop('checked', false);
        $('input[name="address"]', $form).val("");
        $('input[name="phone"]', $form).val("");
        $('input[name="mobilephone"]', $form).val("");
        $('input[name="fax"]', $form).val("");
        $('input[name="gender"]', $form).val("");
        $('input[name="customxml"]', $form).val("");
        $('input[name="terms"]', $form).prop('checked', false);

        cf.reset();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cf.validate();
        var val2 = form.validateRecaptcha();

        if (val1 && val2) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error', $form).first().offset().top - 100 }, 400);
            }
        }

    });

    $form.on('click', '.js-reset-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.reset();
    });

    $form.on('keyup', 'input[name], textarea[name]', function (e) {
        if (e.keyCode === 13) {

            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            form.submit();

            return;
        }

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        cf.validate(fieldName);
    });

    $(".view-terms").fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        maxWidth: 940,
        helpers: {
            overlay: {
                locked: true
            }
        }
    });

    //init validation options
    var validationOptions = {};

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        validationOptions[inputName] = { required: inputName + '-required' };
    });

    //add email validation if exists
    if ($('input[name="email"]', $form).length > 0) {
        validationOptions.email = validationOptions.email || {};
        _.extend(validationOptions.email, { isEmail: 'email-invalid' });
    }

    //add phone validation if exists
    if ($('input[name="phone"]', $form).length > 0) {
        validationOptions.phone = validationOptions.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            _.extend(validationOptions.phone, { isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } });
        } else {
            _.extend(validationOptions.phone, { isPhoneNumber: 'phone-invalid' });
        }
    }

    //add mobile phone validation if exists
    if ($('input[name="mobilephone"]', $form).length > 0) {
        validationOptions.mobilephone = validationOptions.mobilephone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            _.extend(validationOptions.mobilephone, { isValidPhoneLocalized: { validator: 'mobilephone-invalid', config: { type: 'mobile' } } });
        } else {
            _.extend(validationOptions.mobilephone, { isPhoneNumber: 'mobilephone-invalid' });
        }
    }

    //add consent validations
    $.each($('div.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = { checkboxRequired: consentType + '-required' };
    });

    var $consents = $('.form-row.consent input[type="checkbox"]', $form);

    $consents.on('click', function () {
        var fieldName = $(this).attr('name');
        cf.validate(fieldName);
    });

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                cf = $form.data('validationEngine');
                cf.validate('phone');
            });
        }
        if ($('input[name="mobilephone"]', $form).length > 0) {
            $('input[name="mobilephone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.mobilephone = $(this).val();
                cf = $form.data('validationEngine');
                cf.validate('mobilephone');
            });
        }
    }

    Vendd.MessageBus.subscribe(Vendd.Landing.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Landing.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submit);
});

